export default {"src":"/_next/static/media/arrow-left.38dab1c3.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};